import React from 'react';

/** Lightweight CSS tooltip — replaces MUI Tooltip for simple text hints. */
const Tooltip = ({ title, children, className = '' }) => {
  if (!title) return children;
  return (
    <span className={`group relative inline-flex ${className}`}>
      {children}
      <span className="pointer-events-none absolute bottom-full left-1/2 z-50 mb-1.5 -translate-x-1/2 whitespace-nowrap rounded-md bg-slate-800 px-2 py-1 text-xs text-white opacity-0 shadow transition-opacity group-hover:opacity-100">
        {title}
      </span>
    </span>
  );
};

export default Tooltip;
